import React from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

import LogRocket from 'logrocket'
import { init, browserTracingIntegration } from '@sentry/react'

import 'react-datepicker/dist/react-datepicker.css'
import './react-datepicker-undivided.css'
import './index.css'

import { apiHost } from './auth'
import { API, ENVIRONMENT, LOGROCKET_APP_ID, SENTRY_DSN, VERSION } from './env'

import App from './App'

// Unregisters any service worker the browser may already have for this origin.
// CRA's project template historically did this via src/serviceWorker.js; the
// register half was never used here, so only the unregister survives.
const unregisterServiceWorker = () => {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then(registration => registration.unregister())
      .catch(error => console.error(error.message))
  }
}

const logRocketAppId = `${LOGROCKET_APP_ID}`
if (logRocketAppId !== 'disabled') {
  LogRocket.init(`${LOGROCKET_APP_ID}/undivided-apps`, {
    mergeIframes: true,
    childDomains: ['*'],
    release: VERSION
  })
}

if (SENTRY_DSN) {
  init({
    dsn: SENTRY_DSN,
    integrations: [browserTracingIntegration()],
    tracesSampleRate: 0.1,
    ignoreErrors: [
      'ResizeObserver loop limit exceeded',
      'Non-Error promise rejection captured',
      /specialx-asset-thumbnails-.*\.s3\.amazonaws\.com/i
    ],
    denyUrls: [/extensions\//i, /^chrome:\/\//i],
    environment: ENVIRONMENT,
    release: VERSION
  })
}

const startup = async () => {
  await apiHost(API)

  const container = document.getElementById('root')
  const root = createRoot(container)

  root.render(
    <BrowserRouter basename="/app">
      <App />
    </BrowserRouter>
  )

  unregisterServiceWorker()
}

startup()
